import { useEffect } from 'react';
import type { RefAttributes } from 'react';

import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import type { DataGridProps, GridColDef } from '@mui/x-data-grid';

import { useUiContext } from '../../contexts/UiContext/hooks/useUiContext.hook';

import { DefaultToolbar } from './DefaultToolbar';
import { defaultGetRowId } from './utils/default-get-row-id.util';
import { getMatchSorterQuickFilterFn } from './utils/get-match-sorter-quick-filter-fn.util';
import type { DefaultRowModel } from './types/default-row-model.type';

export const DataGrid = <R extends DefaultRowModel = DefaultRowModel>(
  customProps: Readonly<DataGridProps<R> & RefAttributes<HTMLDivElement>>,
) => {
  const { columns } = customProps;

  const props = {
    getRowId: defaultGetRowId,
    ignoreDiacritics: true,
    keepNonExistentRowsSelected: true,
    loading: false,
    showToolbar: true,
    slots: { toolbar: DefaultToolbar },
    ...customProps,
    columns: columns.map(
      (column) =>
        ({
          getApplyQuickFilterFn: getMatchSorterQuickFilterFn,
          ...column,
        }) as GridColDef<R>,
    ),
  };

  const { showDataGrid, hideDataGrid } = useUiContext();

  useEffect(() => {
    const token = showDataGrid();

    return () => {
      hideDataGrid(token);
    };
  }, [showDataGrid, hideDataGrid]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiDataGrid {...props} />;
};
